// extracted by mini-css-extract-plugin
export default {"page":"style_page__bXdiI"};